export default __webpack_public_path__ + "11cc6270a3516e9016f237348536116e.png";